import {
  createFrontendModule,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { createPermission } from '@backstage/plugin-permission-common';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import { PipelinesPage } from './PipelinesPage';

export const pipelinesRouteRef = createRouteRef();

const pipelinesPage = PageBlueprint.make({
  name: 'pipelines',
  params: {
    path: '/pipelines',
    title: 'Pipelines',
    icon: <AccountTreeIcon />,
    routeRef: pipelinesRouteRef,
    loader: async () => <PipelinesPage />,
  },
});

export const pipelinesReadPermission = createPermission({
  name: 'pipeline-registration.read',
  attributes: { action: 'read' },
});

export const pipelinesModule = createFrontendModule({
  pluginId: 'app',
  extensions: [pipelinesPage],
});
